export default function calculateMainProduct (stations) {
    return stations.map((station) => {
        const mainPrices = station.products.reduce((minPrice, product) => {
            if (!minPrice.webPrice.amountInMinorUnits) {
                return {
                    webPrice: product.totalPrice,
                    originalPrice: product.originalPrice,
                }
            }
            if (minPrice.webPrice.amountInMinorUnits > product.totalPrice.amountInMinorUnits) {
                return {
                    webPrice: product.totalPrice,
                    originalPrice: product.originalPrice,
                }
            }
            return minPrice
        }, {webPrice: {}, originalPrice: {}})
        return {
            ...station,
            webPrice: mainPrices.webPrice,
            originalPrice: mainPrices.originalPrice,
        }
    })
}
